
export default (store) => ({
  path: 'statements',
  /*  Async getComponent is only invoked when route matches   */
  getComponent (nextState, cb) {
    /*  Webpack - use 'require.ensure' to create a split point
        and embed an async module loader (jsonp) when bundling   */
    require.ensure([], (require) => {
      /*  Webpack - use require callback to define
          dependencies for bundling   */
      const Statements = require('./containers/StatementsContainer').default

      /*  Return getComponent   */
      cb(null, Statements)

    /* Webpack named bundle   */
    }, 'Statements')
  }
})



/** WEBPACK FOOTER **
 ** ./src/routes/Auth/routes/Discovery/routes/MoneyTool/routes/Statements/index.js
 **/